import { ImgHTMLAttributes } from 'react';

const aztecMagic = '/avatars/aztecMagic.webp';
const bastet = '/avatars/bastet.webp';
const bookOfCats = '/avatars/bookOfCats.webp';
const bookOfDead = '/avatars/bookOfDead.webp';
const buffalo = '/avatars/buffalo.webp';
const defaultCharacter = '/avatars/defaultCharacter.webp';
const dragonPearls = '/avatars/dragonPearls.webp';
const elvisFrog = '/avatars/elvisFrog.webp';
const gatesOfOlympus = '/avatars/gatesOfOlympus.webp';
const johnnyCash = '/avatars/johnnyCash.webp';
const moneyTrain = '/avatars/moneyTrain.webp';
const wolfTreasure = '/avatars/wolfTreasure.webp';

export interface AvatarProps {
  isSelected?: boolean;
}

export interface ScAvatarProps {
  isListItem?: boolean;
}

export type AvatarData = ImgHTMLAttributes<HTMLImageElement> &
  AvatarProps &
  ScAvatarProps;

interface FullAvatarData {
  avatar: AvatarData;
}

export enum AvatarNames {
  MONEY_TRAIN = 'moneyTrain',
  BOOK_OF_CATS = 'bookOfCats',
  DRAGON_PEARLS = 'dragonPearls',
  WOLF_TREASURE = 'wolfTreasure',
  BOOK_OF_DEAD = 'bookOfDead',
  BASTET = 'bastet',
  AZTEC_MAGIC = 'aztecMagic',
  ELVIS_FROG = 'elvisFrog',
  BUFFALO = 'buffalo',
  JOHNNY_CASH = 'johnnyCash',
  GATES_OF_OLYMPUS = 'gatesOfOlympus',
  DEFAULT = 'default',
}

export const AVATARS = [
  AvatarNames.MONEY_TRAIN,
  AvatarNames.BOOK_OF_CATS,
  AvatarNames.DRAGON_PEARLS,
  AvatarNames.WOLF_TREASURE,
  AvatarNames.BOOK_OF_DEAD,
  AvatarNames.BASTET,
  AvatarNames.AZTEC_MAGIC,
  AvatarNames.ELVIS_FROG,
  AvatarNames.BUFFALO,
  AvatarNames.JOHNNY_CASH,
  AvatarNames.GATES_OF_OLYMPUS,
];

export const chooseAvatar = (imageName: string) => {
  switch (imageName) {
    case AvatarNames.MONEY_TRAIN:
      return moneyTrain;
    case AvatarNames.BOOK_OF_CATS:
      return bookOfCats;
    case AvatarNames.DRAGON_PEARLS:
      return dragonPearls;
    case AvatarNames.WOLF_TREASURE:
      return wolfTreasure;
    case AvatarNames.BOOK_OF_DEAD:
      return bookOfDead;
    case AvatarNames.BASTET:
      return bastet;
    case AvatarNames.AZTEC_MAGIC:
      return aztecMagic;
    case AvatarNames.ELVIS_FROG:
      return elvisFrog;
    case AvatarNames.BUFFALO:
      return buffalo;
    case AvatarNames.JOHNNY_CASH:
      return johnnyCash;
    case AvatarNames.GATES_OF_OLYMPUS:
      return gatesOfOlympus;
    default:
      return defaultCharacter;
  }
};

export const getActiveAvatar = (index: number | null): FullAvatarData => {
  const imageName =
    index !== null && AVATARS[index] ? AVATARS[index] : AvatarNames.DEFAULT;
  const avatar = chooseAvatar(imageName);

  return {
    avatar: {
      src: avatar,
      alt: imageName,
      width: 40,
      height: 40,
    },
  };
};
